<template>
  <div class="dataRegistration">
    <div class="dataRegistration_main">
      <div class="childPageTemp_banner">
        <div class="childPageTemp_banner_content">
          <img
            v-if="wWidth > 768"
            src="../../assets/PaginationBanner.png"
            alt
          />
          <img
            v-if="wWidth < 768"
            src="../../assets/mobile/PaginationBanner_Mobile@2x.png"
            alt
          />
          <div
            :class="`childPageTemp_title childPageTemp_title_${$i18n.locale}`"
          >
            <div>{{ title }}</div>
          </div>
        </div>
      </div>
      <div
        class="dataRegistration_top"
        @click.stop="stop"
        v-if="$route.meta.showSteps"
      >
        <el-checkbox-group
          v-model="tabPosition"
          @change="tabChange"
          :class="`dataRegistration_top-checkbox${DataRegistrationRoutes.length}`"
        >
          <!-- :disabled="!$store.state.firstApplicationCheck && item.path != '/formData'" -->
          <el-checkbox-button
            v-for="(item, index) in DataRegistrationRoutes"
            :key="item.name"
            :label="index"
            :disabled="index > tabPosition[tabPosition.length - 1]"
          >
            <div
              :class="
                index < tabPosition[tabPosition.length - 1] ? 'isComplete' : ''
              "
              :style="
                $i18n.locale == 'PT' && $store.state.isMobile
                  ? 'font-size:12px'
                  : ''
              "
            >
              <i
                v-if="index < tabPosition[tabPosition.length - 1]"
                class="el-icon-circle-check"
              ></i>
              <span v-else>{{ serial[index] }}</span>
              <span>&nbsp;{{ $t(item.meta.name) }}</span>
            </div>
            <div
              v-if="
                index &&
                tabPosition[tabPosition.length - 1] == index &&
                index + 1 != DataRegistrationRoutes.length
              "
              class="data_triangle_left"
            ></div>
            <div
              v-if="
                tabPosition[tabPosition.length - 1] == index &&
                index + 1 != DataRegistrationRoutes.length
              "
              class="data_triangle_right"
            ></div>
            <div
              v-else-if="
                index > tabPosition[tabPosition.length - 1] &&
                index + 1 != DataRegistrationRoutes.length
              "
              class="data_arrow"
            ></div>
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div class="dataRegistration_content">
        <!-- <keep-alive> -->
        <router-view></router-view>
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  DataRegistrationRoutes,
  hzmbMoRenewRoutes,
  hzmbGFirstAppRoutes,
  hzmbGInsuranceAppRoutes,
  hzmbHFirstAppRoutes,
  hzmbChangeVDAppRoutes,
} from "../../router";
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
// import { getBusiness } from "@/api/Booking/BookingApplicationAPI";
import { wordBreak } from "@/filters";
export default {
  data() {
    return {
      loading: false,
      firstLoad: true,
      tabPosition: [],
      tabPosition2: [],
      serial: ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"],
    };
  },
  watch: {
    "$route.path"() {
      window.scrollTo(0, 0);
      this.setTab();
    },
  },
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
    title() {
      const serviceName =
        this.$store.state.serviceTypeConfig[`name${this.$t("message.lan")}`];
      const { serviceType: paramsServiceType } = this.$route.params;
      const { serviceType: metaServiceType } = this.$route.meta;
      const serviceType =
        paramsServiceType ||
        metaServiceType ||
        localStorage.getItem("serviceType");
      let msg = "";
      switch (serviceType) {
        case "HZMB_G_FIRST":
        case "HZMB_G_RENEW":
        case "HZMB_G_CANCEL":
          msg = `${this.$t("hzmbG.title.hzmbG")}\n${serviceName}`;
          break;
        case "HZMB_H_FIRST":
        case "HZMB_H_CANCEL":
        case "HZMB_H_FIRST_PERSON":
        case "HZMB_H_RENEW_PERSON":
        case "HZMB_H_CANCEL_PERSON":
        case "HZMB_H_FIRST_COMP":
        case "HZMB_H_RENEW_COMP":
        case "HZMB_H_CANCEL_COMP":
        case "HZMB_H_BOOKING":
          msg = `${this.$t("message.entries.home.hzmbH")}\n${serviceName}`;
          break;
        default:
          msg = serviceName;
          break;
      }
      return msg;
    },
    DataRegistrationRoutes() {
      const { serviceType: routeServiceType } = this.$route.meta;
      const serviceType =
        routeServiceType || localStorage.getItem("serviceType");
      switch (serviceType) {
        case "HZMB_MO_RENEW_PERSON":
        case "HZMB_MO_RENEW_COM":
          return hzmbMoRenewRoutes;
        case "HZMB_G_FIRST":
          return hzmbGFirstAppRoutes;
        case "HZMB_G_INSURANCE":
          return hzmbGInsuranceAppRoutes;
        case "HZMB_H_FIRST":
          return hzmbHFirstAppRoutes;
        case "HZMB_CHANGE_PERSON":
        case "HZMB_CHANGE_COMP":
          return hzmbChangeVDAppRoutes;
        case "HZMB_GH_CHANGE_COMP":
          return hzmbChangeVDAppRoutes.filter(
            (e) => e.name !== "hzmbChangeVDPayment"
          );
        default:
          return DataRegistrationRoutes.filter(
            (item) => item.meta.type === "HZMB"
          );
      }
    },
  },
  methods: {
    tabChange() {
      this.tabPosition = this.tabPosition2;
    },
    stop() {
      return false;
    },
    // 頂部步驟條數據
    setTab() {
      const routeIndex = this.DataRegistrationRoutes.findIndex(
        (item) => item.name == this.$route.name
      );
      for (let i = -1; i < routeIndex; i++) {
        this.tabPosition = [i + 1];
        this.tabPosition2 = [i + 1];
      }
    },
  },
  async created() {
    // 沒有選擇過申請類型或serviceType，跳轉回主頁
    // if(this.$store.state.serviceType == 'TAXI'){
    //   return false;
    // }
    const serviceType = localStorage.getItem("serviceType");
    const verifyForm = JSON.parse(localStorage.getItem("verifyForm"));
    const personalType = localStorage.getItem("personalType");
    if (serviceType) {
      this.$store.commit("changeVerifyForm", verifyForm);
      this.$store.commit("changePersonalType", personalType);
    } else {
      this.$router.push("/");
      return false;
    }
    this.firstLoad = false;

    this.$store.commit("changeServiceType", serviceType);
    this.loading = true;
    try {
      let config = {};
      if (this.$route.meta.type === "BOOKING") {
        // config = await getBusiness(serviceType);
        config = {};
      } else {
        config = await ServiceTypeConfigAPI.getDetails(serviceType);
      }
      this.loading = false;
      config.nameTc = wordBreak(config.nameTc);
      config.nameSc = wordBreak(config.nameSc);
      config.namePt = wordBreak(config.namePt);
      config.nameEn = wordBreak(config.nameEn);
      this.$store.commit("changeServiceTypeConfig", config);
    } catch (error) {
      this.loading = false;
      this.$error(error);
    }
    this.setTab();
  },
};
</script>

<style lang="scss" scoped>
.dataRegistration {
  background: rgba(227, 227, 227, 1);
  overflow: hidden;
}
.dataRegistration_main {
  // max-width: 1200px;
  // margin: 24px auto;
  background: #fff;
}
.dataRegistration_top {
  background-color: #f0f8f8;
  padding: 12px;
  text-align: center;
  /deep/.el-checkbox-button__inner {
    background-color: transparent;
  }
}
/deep/.el-checkbox-group {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(240, 240, 240, 1) 100%
  );
  border-radius: 4px;
  border: 1px solid rgba(220, 226, 233, 1);
  overflow: hidden;
  max-width: 650px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: auto;
  .el-checkbox-button__inner {
    position: relative;
    border: 0;
    max-width: 241px;
    width: 100%;
    font-size: 20px;
    border-right: 1px solid #38959d;
    cursor: default;
    padding: 10px 10px;
    font-weight: 600;
  }
  .el-checkbox-button__inner:last-child {
    border-right: 0px;
  }
  .el-checkbox-button {
    flex: 1;
  }
  .el-checkbox-button__orig-checkbox:checked + .el-checkbox-button__inner {
    background: linear-gradient(
      180deg,
      rgba(102, 196, 204, 1) 0%,
      rgba(38, 136, 145, 1) 100%
    );
    box-shadow: initial;
  }
  //   .el-checkbox-button__inner:hover {
  //     color: #7fbbf8;
  //   }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    background: linear-gradient(
      180deg,
      rgba(102, 196, 204, 1) 0%,
      rgba(38, 136, 145, 1) 100%
    );
  }
  .el-checkbox-button.is-checked:first-child
    .el-checkbox-button__inner
    .data_triangle {
  }
}
/deep/.el-checkbox-group.dataRegistration_top-checkbox2 {
  max-width: 482px;
}
/deep/.el-checkbox-group.dataRegistration_top-checkbox4 {
  max-width: 900px;
}
.dataRegistration_content {
  min-height: 800px;
  overflow: hidden;
}
.data_triangle_left {
  position: absolute;
  top: 0;
  left: -1px;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-left: 20px solid #f7f7f7;
  border-bottom: 20px solid transparent;
}
.data_triangle_right {
  position: absolute;
  width: 0px;
  height: 0px;
  border-left: 20px solid transparent;
  border-top: 20px solid #fcfcfc;
  border-bottom: 20px solid #f1f1f1;
  top: 0;
  right: 0px;
}
.data_arrow {
  position: absolute;
  top: 6px;
  right: 0;
  display: inline-block;
  border-top: 1px solid;
  border-right: 1px solid;
  width: 28px;
  height: 28px;
  border-color: #d9e0e8;
  transform: rotate(45deg);
  z-index: 100;
}
.isComplete {
  font-size: 20px;
  font-weight: 600;
  color: rgba(136, 136, 136, 1);
}
.dataRegistration_title {
  font-size: 28px;
  background: #fff;
  color: #333;
  text-align: center;
  padding: 1%;
}
.childPageTemp_title div {
  justify-content: flex-start;
}

@media screen and (max-width: 1300px) {
  .childPageTemp_title div {
    font-size: 42px;
    line-height: 58px;
  }
}
@media screen and (max-width: 996px) {
  .childPageTemp_title div {
    font-size: 30px;
    line-height: 44px;
  }
}
@media screen and (max-width: 767px) {
  .dataRegistration_main {
    margin: 0 auto;
  }
  /deep/.el-checkbox-group {
    .el-checkbox-button__inner {
      font-size: 14px;
    }
  }
  .isComplete {
    font-size: 14px;
  }
  .data_triangle_left {
    border-top: 17px solid transparent;
    border-left: 15px solid #f7f7f7;
    border-bottom: 17px solid transparent;
  }
  .data_triangle_right {
    border-left: 15px solid transparent;
    border-top: 17px solid #fcfcfc;
    border-bottom: 17px solid #f1f1f1;
  }
  .data_arrow {
    top: 3px;
  }
  .childPageTemp_banner div {
    font-size: 22px;
    line-height: 35px;
  }
}
@media screen and (min-width: 768px) {
  .childPageTemp_title span {
    font-size: 48px;
  }
}
</style>

<style>
.next_btn {
  text-align: center;
  padding-top: 76px;
  padding-bottom: 160px;
  background: #fff;
}

@media screen and (max-width: 767px) {
  .next_btn {
    padding-bottom: 76px;
  }
  .next_btn .el-button {
    margin-left: 0;
    margin-bottom: 24px;
  }
}
</style>
